import {isStandardDuration} from './datetime'

//maps a field liek reps/weight/incline to a priority value
//that should be used to correctly sort these anywhere they
//are displayed
export const workoutFieldsPriorityMap = {
	exercise:{
		reps:0,
		weight:1,
		time:2,
		rest:3,
		notes:4
	},
	cardio:{
		time:0,
		distance:1,
		resistance:2,
		incline:3,
		rest:4,
		notes:5
	}
}

//checks if workout is playable
export const workoutIsPlayable = workout => {
	const {compact_mode,routine} = workout
	//empty routines are not playable
	if(routine?.length === 0||compact_mode||!routine) return false
	//loop over each exercise group in the routine
	for (var i = routine.length - 1; i >= 0; i--) {
		const group = routine[i]
		//headings have no affect on playability
		if(!['superset','cardioSingleton','exerciseSingleton'].includes(group.type)) continue
		//loop over each exercise in the group
		for (var j = group.exercises.length - 1; j >= 0; j--) {
			const exercise = group.exercises[j]
			if (exercise.type === 'placeholder') continue
			//loop over each set
			for (var k = exercise.set_data.length - 1; k >= 0; k--) {
				const set = exercise.set_data[k]
				//loop over each assigned value
				for(let key in set.assigned){
					const val = set.assigned[key]
					//check if rest/time values are valid durations that can be 
					//used for guided/playable workouts
					if(
						//standard check
						(['rest','time'].includes(key)&&!isStandardDuration(val))&&
						//additionally allow empty string rest values to be considered valid
						!(key==='rest'&&val==='')
					){
						return false
					}//end if is valid
				}//end for(key in assigned)
			}//end for(exercise.set_data)
		}//end for(group.exercises)
	}//end for(routine)
	return true
}